<template>
  <div class="api-log">
    <!-- 条件搜索部分 -->
    <el-form class="zwx-form" key="mainForm" ref="mainForm" :model="mainForm" label-position="right" @submit.native.prevent>
      <div style="max-width: 514px;">
        <el-form-item label-width="84px" label="登录IP：">
          <el-input class="zwx-input" v-model="mainForm.requestIp" placeholder="请输入" @keyup.enter.native="search(1)" clearable />
        </el-form-item>
        <el-form-item label-width="70px" label="请求地址：">
          <el-input class="zwx-input" v-model="mainForm.requestUrl" placeholder="请输入" @keyup.enter.native="search(1)" clearable />
        </el-form-item>
        <el-form-item label-width="84px" label="返回状态码：">
          <el-input class="zwx-input" v-model="mainForm.returnStatus" @input="$validate.nonnegativeInteger($data['mainForm'], 'returnStatus')" placeholder="请输入" @keyup.enter.native="search(1)" clearable />
        </el-form-item>
        <el-form-item label-width="70px" label="请求耗时：">
          <el-input class="zwx-input" v-model="mainForm.diffTimeMax" @input="$validate.nonnegativeInteger($data['mainForm'], 'diffTimeMax')" placeholder="大于等于多少毫秒" @keyup.enter.native="search(1)" clearable />
        </el-form-item>
      </div>
    </el-form>
    <el-divider class="base-divider" />
    <div style="padding: 12px 20px;">
      <el-button class="zwx-button zwx-button-icontext-28" type="primary" icon="el-icon-search" @click="search(1)">查询</el-button>
    </div>
    <!-- 列表展示部分 -->
    <el-table class="zwx-table" style="width: 100%;" row-key="rid" :data="dataList" border stripe>
      <el-table-column prop="userNo" label="用户账号" :width="$system.calWidth(dataList, 'userNo', '用户账号')" header-align="left" align="left"/>
      <el-table-column prop="requestIp" label="登录IP" :width="$system.calWidth(dataList, 'requestIp', '登录IP')" header-align="center" align="center"/>
      <el-table-column prop="returnStatus" label="返回状态码" :width="$system.calWidth(dataList, 'returnStatus', '返回状态码')" header-align="center" align="center"/>
      <el-table-column prop="diffTime" label="请求耗时" :width="$system.calWidth(dataList, 'diffTime', '请求耗时')" header-align="center" align="center"/>
      <el-table-column prop="createTime" label="请求时间" :width="$system.calWidth(dataList, 'createTime', '请求时间')" header-align="center" align="center"/>
      <el-table-column prop="requestUrl" label="请求地址" :width="$system.calWidth(dataList, 'requestUrl', '请求地址')" header-align="left" align="left"/>
      <el-table-column fixed="right" label="操作" :min-width="$system.calMinWidth({ wordNum: 2, arrowNum: 0, btnNum: 1 })" header-align="left" align="left">
        <template slot-scope="scope">
          <el-button class="zwx-button zwx-button-text-26" type="text" @click="apiLogDialogClick(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器部分 -->
      <zwx-pagination :parentPage="currentPage" :pageSize="pageSize" :total="total" @currentChange="currentChange" />
    <!-- 弹框 -->
    <base-dialog ref="apiLogDialog" @determine="apiLogDialogDetermine()" @close="apiLogDialogColse()" title="查看" :pagination="false" :ifCancel="false">
      <div style="padding: 0 10px;">
        <span style="word-break: break-all;white-space: pre-wrap;font-size: 14px;color: #1f2d3d;">{{apiLogDialogForm.messageContent }}</span>
      </div>
    </base-dialog>
  </div>
</template>

<script>
export default {
  name: 'ApiLog',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      btns: [''],
      mainForm: {
        requestIp: '',
        requestUrl: '',
        returnStatus: '',
        diffTimeMax: '',
      },
      apiLogDialogForm: {
        messageContent: '',
      },
      dataList: [],
      currentPage: 1,
      pageSize: 18,
      total: 0,
    }
  },
  created() {},
  mounted() {
    this.search(this.currentPage)
  },
  activated() {
    if (this.$route.params.fresh) this.search(this.currentPage)
  },
  computed: {},
  methods: {
    currentChange(currentPage) {
      this.search(currentPage)
    },
    search(currentPage) {
      this.$emit('loading', true)
      this.currentPage = currentPage
      let data = {
        currentPage: this.currentPage,
        requestIp: this.mainForm.requestIp,
        requestUrl: this.mainForm.requestUrl,
        returnStatus: this.mainForm.returnStatus,
        diffTimeMax: this.mainForm.diffTimeMax,
      }
      this.$system.get(this.api + '/systematic/getApiLogList-1', data, true, true, this.searchSuccess, this.error)
    },
    searchSuccess(data) {
      if (data.type === '00') {
        this.dataList = data.apiLogList
        this.total = data.apiLogCount
        this.pageSize = data.pageSize
      } else if (data.type === '99') {
        this.$router.push({ name: 'Error', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
      }
      this.$emit('loading', false)
    },
    apiLogDialogClick(row) {
      this.$emit('loading', true)
      let data = {
        rid: row.rid,
      }
      this.$system.get(this.api + '/systematic/getApiLog-1', data, true, true, this.apiLogDialogClickSuccess, this.error)
    },
    apiLogDialogClickSuccess(data) {
      if (data.type === '00') {
        this.msApiLogDialogForm.messageContent = data.apiLog.messageContent
        this.$refs.apiLogDialog.show(true)
      } else if (data.type === '99') {
        this.$router.push({ name: 'Error', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
      }
      this.$emit('loading', false)
    },
    apiLogDialogDetermine() {
      this.$refs.apiLogDialog.show(false)
    },
    apiLogDialogColse() {
      this.apiLogDialogForm.messageContent = ''
    },
    error() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
  },
}
</script>

